import { HttpClient, HttpContext, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SKIP_GLOBAL_ERROR_TOAST } from '../helpers/http-context.tokens';

export interface SignData {
  // documentId?: string;
  pdfUrl: string;
  signatureDetail: any;
  name: string;
  esignType?: string;
  navigate?: string;
  signerIndex?: number;
  editable?: boolean;
}

export interface Signer {
  name: string;
  email: string;
  esignType: string;
  phone: string;
  signatureDetail: any[];
}

@Injectable({
  providedIn: 'root'
})
export class DocumentService {

  constructor(private http: HttpClient) { }
  private apiUrl = '';

  documentStatusByTxn(txnId: string) {
    return this.http.get(`${this.apiUrl}/documents/document-by-txn/${txnId}`)
  }

  private _signers: Signer[] = [];

  get getSigners(): Signer[] {
    return this._signers;
  }

  set setSigners(value: Signer[]) {
    this._signers = value || [];
  }

  updateSigners(value: Signer[]): void {
    if (!this._signers || this._signers.length === 0) {
      this._signers = value || [];
      return;
    }

    value.forEach((item, index) => {
      if (this._signers[index]) {
        this._signers[index] = {
          ...this._signers[index],
          ...item
        };
      } else {
        this._signers.push(item);
      }
    });

    while (this._signers.length > value.length) {
      this._signers.pop();
    }
  }
}
